import api from '@/lib/api';
import type {
  ShareOrganizationRequestDto,
  ShareOrganizationResponseDto,
} from '@/types/organization';

export interface Organization {
  _id: string;
  name: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

class OrganizationService {
  private readonly baseUrl = '/organization';

  async share(
    organizationId: string,
    dto: ShareOrganizationRequestDto
  ): Promise<ShareOrganizationResponseDto> {
    const response = await api.post<ShareOrganizationResponseDto>(
      `${this.baseUrl}/share/${organizationId}`,
      dto
    );
    return response.data;
  }

  async getMyOrganizations(): Promise<Organization[]> {
    const response = await api.get<Organization[]>(
      `${this.baseUrl}s/my-organizations`
    );
    return response.data;
  }
}

const organizationService = new OrganizationService();
export default organizationService;
